let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iL38F")).then(() => parcelRequire('5DyWZ'));